import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { EMPTY_IMAGE } from '../card/FrameCard';
import CommonModal from '../../../../../components/common-modal/CommonModal';
import FrameSlider from '../../../../../id8/components/frames/slider/FrameSlider';
import PreviewDemoSlide from '../card/slide/PreviewDemoSlide';

import scss from './PreviewModal.module.scss';

function PreviewModal({ isOpen, onClose, frameData, onLike, onShowSourceImage }) {
  const { t } = useTranslation('id8');

  const currentImageData = frameData ?? EMPTY_IMAGE;

  const handleShowSourceImage = () => {
    onShowSourceImage(frameData);
  };

  return (
    <>
      <CommonModal isOpen={isOpen} onClose={onClose} isAnimated>
        <div className={scss.wrapper}>
          <FrameSlider
            images={[frameData]}
            onLike={onLike}
            isGenerating={frameData?.generating}
            sliderWrapperClassName={scss.sliderWrapper}
            onShowSourceImage={handleShowSourceImage}
            contrastedArrows
            enableArrowNavigation
            Slide={PreviewDemoSlide}
          />

          <div className={scss.content}>
            <div className={scss.header}>
              <span className={scss.title}>
                <span>{currentImageData.ideaHeadline}</span>
                <span> {currentImageData.copy}</span>
                <span> {currentImageData.advertisingStatement}</span>
              </span>
            </div>

            <div className={scss.textContent}>
              {currentImageData.campaignIdea ? (
                <span className={scss.labeledText}>
                  <b>{t('campaignIdea')}: </b>
                  {currentImageData.campaignIdea}
                </span>
              ) : null}
              {currentImageData.strategyInsight ? (
                <span className={scss.labeledText}>
                  <b>{t('strategyInsight')}: </b>
                  {currentImageData.strategyInsight}
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </CommonModal>
    </>
  );
}

export default memo(PreviewModal);
